/**
 * Trunnion AI - Favorites Hook
 * Convenience wrapper around uiStore favorites.
 */

import { useCallback } from 'react';
import { useUIStore } from '@/stores/uiStore';

export function useFavorites() {
  const { favorites, toggleFavorite, isFavorite } = useUIStore();

  const toggle = useCallback(
    (type: string, id: string, label: string) => {
      toggleFavorite(type, id, label);
    },
    [toggleFavorite],
  );

  const check = useCallback(
    (type: string, id: string) => {
      return isFavorite(type, id);
    },
    [isFavorite],
  );

  const getByType = useCallback(
    (type: string) => {
      return favorites.filter((f) => f.type === type);
    },
    [favorites],
  );

  return {
    favorites,
    toggleFavorite: toggle,
    isFavorite: check,
    getByType,
  };
}
